import { getAuthCode } from "./getAuthCode";
export const schedulePost = async (id,date,postingToLinkedIn = false) => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/schedulePost?id=" + id+"&date="+date;
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode(), postingToLinkedIn})
      });
      const result = await response.json();
      window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'post_scheduled',
        });  
      window.location.href = '/schedule';
    } catch (error) {
      console.log(error);
    }
  };